import React, { Component } from 'react';

class Sectionheader extends Component {
    render() {
        return (
        <div className="section__header dash__headers d-flex col-8 d-flex align-items-center mt-4 align-items-center">
            <div className='d-flex align-items-center  px-0'>
              <img src={this.props.icon} className='mr-3' alt="" />
              <h4 className='section__header__txt mr-3'>{this.props.txt} </h4>
            </div>
            <div className='shared__header__line px-0 mt-2 col'></div> 
        </div>
        );
    }
}

export default Sectionheader;
